import { LinearGradient } from "expo-linear-gradient";
import { DEFAULT_IMPACT_BACKGROUND_GRADIENT } from "./constants";
import { ImpactBackgroundGradientProps } from "./types";

/**
 * Note: if `palette` provided then uses primary and secondary as gradient colors (i.e. no tertiary).
 */
const ImpactBackgroundGradient = ({
	baseColor: baseColorProp,
	tintColor: tintColorProp,
	tertiaryColor: tertiaryColorProp,
	palette,
	style,
	children,
	testID,
	pointerEvents,
}: ImpactBackgroundGradientProps) => {
	const baseColor =
		baseColorProp ?? palette?.primary ?? DEFAULT_IMPACT_BACKGROUND_GRADIENT.baseColor;
	const tintColor =
		tintColorProp ?? palette?.secondary ?? DEFAULT_IMPACT_BACKGROUND_GRADIENT.tintColor;
	const tertiaryColor =
		tertiaryColorProp ?? palette?.tertiary ?? DEFAULT_IMPACT_BACKGROUND_GRADIENT.tertiaryColor;

	return palette?.primary && palette.secondary ? (
		<LinearGradient
			pointerEvents={pointerEvents}
			colors={[palette.primary, palette.secondary]}
			style={[
				{
					backgroundColor: baseColor,
				},
				style,
			]}
			testID={testID}
		>
			{children}
		</LinearGradient>
	) : (
		<LinearGradient
			pointerEvents={pointerEvents}
			colors={[baseColor, tintColor, tertiaryColor]}
			locations={[0, 0.5, 0.7]}
			style={[
				{
					backgroundColor: baseColor,
				},
				style,
			]}
			start={{ x: 0.4, y: 0 }}
			end={{ x: 1, y: 1 }}
			testID={testID}
		>
			{children}
		</LinearGradient>
	);
};
export default ImpactBackgroundGradient;
